/* eslint-disable eqeqeq */
import { createSlice , createAsyncThunk,PayloadAction } from "@reduxjs/toolkit";
import { AuthLogin } from "../../../utilities";
import {UserPayload} from "../../../utilities/types"

const initialState={
    status:"",
    message:"",
    otpNumber:0,
    isLoggedIn:false,
    phoneNumber:""
}

export const LoginVerify=createAsyncThunk("LoginPage/fatchUser",(payload:UserPayload)=>AuthLogin(payload))
 
const LoginSlice = createSlice({
    name:"LoginPage",
    initialState,
    reducers:{
        phoneNumber:(state,action)=>{
            state.phoneNumber=action.payload
        },
        resetLoginSlice:()=>initialState
    },
    extraReducers:(builder)=>{
        builder
        .addCase(LoginVerify.pending,(state)=>{
            state.isLoggedIn=true
        })
        .addCase(LoginVerify.fulfilled,(state,action:PayloadAction<any>)=>{
            if(action.payload.status=="200"){
                state.isLoggedIn=false
                state.status = action.payload.status 
                state.message = action.payload.data.message
                state.otpNumber = action.payload.data.data.otpNumber
            }
            else{
                state.isLoggedIn=false
                state.status = action.payload.response.status 
                state.message = action.payload.response.data.message
            }
        })
        .addCase(LoginVerify.rejected,(state,obj)=>{
            state.isLoggedIn=false
        })
    }
})

export default LoginSlice.reducer
export const {phoneNumber,resetLoginSlice} = LoginSlice.actions
